import { useState } from 'react';
import { useSelector } from "react-redux";
import ManageTripsModal from './ManageTripsModal';
import TripSelect from './TripSelect';
import { Stack, Box, LinkBox, LinkOverlay, Text, InputGroup, IconButton } from '@chakra-ui/react';
import { AddIcon, WarningIcon } from '@chakra-ui/icons';

export default function TripSelectionSubform({ preselectedTripId, setSelectedTrip, isEditing }) {
    const { isLoading } = useSelector((state) => state.trips);
    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            <ManageTripsModal isOpen={isOpen} setIsOpen={setIsOpen} />
            <Stack direction='column' spacing={0} align='center'>
                <InputGroup>
                    <Box w='full'>
                        <TripSelect
                            isDisabled={isLoading}
                            unassignedOptionLabel='Unassigned'
                            preselectedTripId={preselectedTripId ? preselectedTripId : undefined}
                            setSelectedTripId={setSelectedTrip}
                            isInModal={isEditing}
                        />
                    </Box>

                    <IconButton
                        onClick={() => setIsOpen(true)}
                        icon={<AddIcon />}
                    />
                </InputGroup>
                <LinkBox w='full'>
                        <LinkOverlay onClick={() => setIsOpen(true)}>
                            <Box align='center'>
                                <Text fontSize='sm' color='blue.900' as='u'>
                                    Manage trips
                                </Text>
                            </Box>
                        </LinkOverlay>
                </LinkBox>
            </Stack>
        </>
    );
}